/**
 * @file Re-exports the investment transfer modal as the module's public entry point.
 */
import InvestmentsTransferModal from "./InvestmentsTransferModal";

export default InvestmentsTransferModal;
